export const formatDate = (x) => {

    if(x ===null)return x
    
    let date = new Date(x);

    var dd = date.getDate();
    var mm = date.getMonth() + 1;

    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    return dd + "/" + mm + "/" + yyyy;
}

export const formatCurrency = (x) => {
    let delimiter = " ";
    let groupsOf = 3
    let result = (''+x).split('.'), s = '', i, j;
    i = result[0].length;
    while (i > groupsOf) {
        j = i - groupsOf;
        s = delimiter + result[0].slice(j, i) + s;
        i = j;
    }
    s = result[0].slice(0, i) + s;
    result[0] = s;
    return result.join('‧');
}
